import { Alert, Stack, Typography, Button } from "@mui/material"
import { Link } from "react-router-dom"


export default function NotFound(){

    return <Stack alignItems='center' spacing={3} sx={{mt: 3}}>

        <Typography variant='h1'>Erreur 404</Typography>

        <Alert severity='warning'>La page que vous recherchez n'existe pas.</Alert>

        <Link to='/'>
            <Button>Retour à l'accueil</Button>
        </Link>

    </Stack>
}